export default __webpack_public_path__ + "static/media/brownies.713d5110.webp";